import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/components/EventsAwardsAccordionHeader";

/**
 * Component to render benefits section for FAQ Page
 */
const BenefitsSection = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150 font-public-sans"
      data-testid="benefits-section-component"
    >
      <AccordionV2
        testId="benefits"
        className="border-none py-2"
        headerChildren={
          <EventsAwardsAccordionHeader
            title="What are the benefits of this set of awards?"
            className="px-4"
          />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mx-4 mt-2 px-6 py-4 pb-0">
          <p>
            The biggest reward is the recognition and honour accorded to
            companies and individuals for their exemplary achievements in
            corporate disclosure and corporate governance, endorsed by the SGX
            and ACRA, and all the relevant professional bodies and institutions
            associated with the capital market.
          </p>

          <p>
            Through the years, the Singapore Corporate Awards has grown to be
            the one of the most prestigious awards in Singapore&apos;s corporate
            calendar that recognises and celebrates the best in corporate
            governance.
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default BenefitsSection;
